/**
 * Shapes of the platform API (`/auth/me`, `/users`, `/organizations`), as the browser sees them.
 * They match @getaways/extranet-platform; resource IDs live under the app's own membership field.
 */

export interface Organization {
  id: string;
  name: string;
  kind: "operator" | "partner";
  status: "active" | "inactive";
}

export interface UserMembership {
  organizationId: string;
  role: string;
}

export interface PublicUser<M extends UserMembership = UserMembership> {
  id: string;
  email: string;
  name: string;
  status: "active" | "inactive";
  memberships: M[];
  createdAt: string;
  lastLoginAt?: string | undefined;
}

export interface Me<M extends UserMembership = UserMembership> {
  user: PublicUser<M>;
  organizations: Organization[];
}

/** How people sign in (`GET /auth/config`): local passwords, or the central login (Zitadel and Resosys Access). */
export type AuthConfig = { mode: "local" } | { mode: "central"; loginUrl: string; accountUrl: string; portalUrl?: string };

/** A resource a membership can be limited to (a property, a station…). */
export interface ScopedResource {
  id: string;
  name: string;
  organizationId: string;
}

/** Display names of an app's roles, e.g. { admin: "Administrador" }. */
export type RoleNames = Record<string, string>;

export const roleSummary = (memberships: readonly UserMembership[], roleNames: RoleNames) => [...new Set(memberships.map((m) => roleNames[m.role] ?? m.role))].join(", ");
